<header class="border-b border-ink/5 bg-snow/90 font-outfit text-ink antialiased backdrop-blur">
  <div class="mx-auto flex max-w-6xl items-center justify-between gap-4 px-5 py-3">
    <a routerLink="/" class="shrink-0 text-[15px] font-semibold tracking-[0.18em] text-ink">GIVE SANTA</a>

    <nav class="hidden items-center gap-7 text-sm text-mute md:flex">
      <a routerLink="/" fragment="how" class="hover:text-ink">{{ "navbar.howItWorks" | translate }}</a>
      <a routerLink="/" fragment="gift" class="hover:text-ink">{{ "navbar.giftCode" | translate }}</a>
      <a routerLink="/faq" class="hover:text-ink">{{ "navbar.faq" | translate }}</a>
    </nav>

    <div class="flex items-center gap-1 sm:gap-2">
      @if (user$ | async; as user) {
        <a
          routerLink="/account"
          class="flex h-9 items-center gap-1.5 rounded-full px-2 text-sm text-mute hover:text-ink"
          [attr.aria-label]="'navbar.account' | translate"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="h-5 w-5"
            aria-hidden="true"
          >
            <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
          </svg>
          <span class="hidden lg:inline">{{ user.firstName }}</span>
        </a>
        <button
          type="button"
          class="flex h-9 w-9 items-center justify-center rounded-full text-mute hover:text-ink"
          [attr.aria-label]="'navbar.logOut' | translate"
          [title]="'navbar.logOut' | translate"
          (click)="logout()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="h-5 w-5"
            aria-hidden="true"
          >
            <path d="m16 17 5-5-5-5" />
            <path d="M21 12H9" />
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
          </svg>
        </button>
      } @else {
        <button
          type="button"
          class="flex h-9 items-center rounded-full px-2 text-sm text-mute hover:text-ink"
          [attr.aria-label]="'navbar.logIn' | translate"
          (click)="login()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="h-5 w-5 sm:hidden"
            aria-hidden="true"
          >
            <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
          </svg>
          <span class="hidden sm:inline">{{ "navbar.logIn" | translate }}</span>
        </button>
      }

      <button
        type="button"
        class="relative flex h-9 w-9 items-center justify-center rounded-full text-mute hover:text-ink"
        [attr.aria-label]="'navbar.cart' | translate"
        (click)="openBasket()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="h-5 w-5"
          aria-hidden="true"
        >
          <path d="M16 10a4 4 0 0 1-8 0" />
          <path d="M3.103 6.034h17.794" />
          <path
            d="M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z"
          />
        </svg>
        @if (count) {
          <span
            class="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-santa px-1 text-[10px] font-semibold text-snow"
          >
            {{ count }}
          </span>
        }
      </button>

      @if (showCta) {
        <a [routerLink]="startStoryUrl" class="cta ml-2 hidden !px-5 !py-2.5 text-xs sm:inline-flex md:text-sm">
          {{ "navbar.startStory" | translate }}
        </a>
      }
    </div>
  </div>
</header>
